import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getPasswordStrength } from '../../../util/password-util';

import PasswordStrengthIndicator from './password-strength-indicator';
import { translate } from '../../../i18n/localize';

function PasswordInput(props) {
  const { onChangePassword } = props;

  const [password, setPassword] = useState('');
  const [strength, setStrength] = useState(0);

  const handleChange = (e) => {
    const password = e.target.value;
    const strength = getPasswordStrength(password);

    setPassword(password);
    setStrength(strength);
    
    onChangePassword(password);
  };

  return (
    <>
      <input type="password"
        placeholder={translate('password.placeholder')}
        name="password"
        value={password}
        onChange={(e) => handleChange(e)}
        onBlur={(e) => handleChange(e)} required />
      { password.length > 0 &&
        <PasswordStrengthIndicator passwordStrength={strength} />
      }
    </>
  );
}

PasswordInput.propTypes = {
  onChangePassword: PropTypes.func 
};

export default PasswordInput;
